import { tutorialSamples } from "@/components/tutorial/tutorialSteps/tutorialSamples";

export const PADDING_TARGET_ELEMENT = 10;

export const DEFAULT_TUTORIAL_SAMPLE = tutorialSamples[2];

export const MIN_CONVERSION_TIME_FOR_TUTORIAL = 10;
